export default __webpack_public_path__ + "535b8d90a8679809ed798a6e7c0a1088.png";